<template>
    <div>
        <vs-dialog prevent-close v-model="active">
           <template v-if="infoCalificacion && infoCalificacion.infoCalifGen" #header>
            <h4 class="not-margin">
                {{infoCalificacion.infoCalifGen.materia}}
            </h4>
             </template>
            <div class="con-form" v-if="infoCalificacion && infoCalificacion.infoCalifGen">
                <p v-if="infoCalificacion.infoCalifGen.docente" class="mb-2">Profesor: <strong>{{infoCalificacion.infoCalifGen.docente}}</strong></p>
                <div v-if="infoCalificacion.tipoModificar.includes('calificacion', 'retardos', 'conducta', 'tareas_no_hechas') || infoCalificacion.infoCalif.calificacion_id != '0'">
                    <p class="mb-0"><strong>{{modificar[infoCalificacion.tipoModificar]}} actual</strong></p>
                    <vs-input v-model="infoCalificacion.calificacionActual" placeholder="Calificacion actual" disabled/>
                </div>
                <div v-if="infoCalificacion.tipoModificar.includes('calificacion', 'retardos', 'conducta', 'tareas_no_hechas') || infoCalificacion.infoCalif.calificacion_id != '0'">
                    <p class="mb-0"><strong>{{modificar[infoCalificacion.tipoModificar]}} nueva</strong></p>
                    <div v-show="infoCalificacion.infoCalifGen && infoCalificacion.infoCalifGen.escala_calificacion && infoCalificacion.infoCalifGen.escala_calificacion.tipo_escala == 'numerica' || (infoCalificacion.tipoModificar == 'faltas' || infoCalificacion.tipoModificar == 'retardos' || infoCalificacion.tipoModificar == 'conducta' || infoCalificacion.tipoModificar == 'tareas_no_hechas')">
                        <form autocomplete="off">
                            <input
                                type="number"
                                :min="infoCalificacion.infoCalifGen && infoCalificacion.infoCalifGen.escala_calificacion && infoCalificacion.infoCalifGen.escala_calificacion.valor_minimo"
                                :max="infoCalificacion.infoCalifGen && infoCalificacion.infoCalifGen.escala_calificacion && infoCalificacion.infoCalifGen.escala_calificacion.valor_maximo"
                                v-model="calif_nueva"
                                @input="validarEntero(infoCalificacion.infoCalifGen.escala_calificacion), validateGrade(calif_nueva, infoCalificacion.tipoModificar)"
                            />
                            <div style="color:red;" v-if="errorFields.includes('calif_nueva')">
                                <small>Requerido</small>
                            </div>
                        </form>
                        <p v-if="noPermitir" style="color: red"><small>El valor debe de estar entre {{infoCalificacion.infoCalifGen.escala_calificacion.valor_minimo}} y {{infoCalificacion.infoCalifGen.escala_calificacion.valor_maximo}}.</small></p>
                    </div>
                    <div v-if="infoCalificacion.infoCalifGen && infoCalificacion.infoCalifGen.escala_calificacion && infoCalificacion.infoCalifGen.escala_calificacion.tipo_escala == 'alfanumerica' && infoCalificacion.tipoModificar == 'calificacion'">
                        <form autocomplete="off">
                            <div style="position:relative">
                               <vs-select placeholder="Calificación no aprobatoria" v-model="alfa_nueva" tabindex="2" :disabled="alfa_nueva_acreditables != ''">
                                    <vs-option v-for="escala in infoCalificacion.infoCalifGen.escala_calificacion.valores_alfanumericos" :key="escala" :label="escala" :value="escala">
                                        {{escala}}
                                    </vs-option>
                                </vs-select>
                                <div style="color:red;" v-if="errorFields.includes('alfa_nueva')">
                                    <small>Requerido</small>
                                </div> 
                                <div v-if="alfa_nueva !== ''" @click="alfa_nueva = ''" class="tache">
                                    <i class="far fa-times-circle"></i>
                                </div>
                            </div>
                            <div style="position:relative">
                                <vs-select placeholder="Calificación aprobatoria" v-model="alfa_nueva_acreditables" tabindex="2" :disabled="alfa_nueva != ''">
                                    <vs-option v-for="escala in infoCalificacion.infoCalifGen.escala_calificacion.valores_alfanumericos_acreditables" :key="escala" :label="escala" :value="escala">
                                        {{escala}}
                                    </vs-option>
                                </vs-select>
                                <div style="color:red;" v-if="errorFields.includes('alfa_nueva_no')">
                                    <small>Requerido</small>
                                </div>
                                <div v-if="alfa_nueva_acreditables !== ''" @click="alfa_nueva_acreditables = ''" class="tache">
                                    <i class="far fa-times-circle"></i>
                                </div>
                            </div>
                            
                        </form>
                    </div>
                </div>
                <div v-else>
                    <h5 class="mt-3">Para agregar una nota en {{modificar[infoCalificacion.tipoModificar]}}, se deberá capturar primero la calificación.</h5>
                </div>
            </div>

            <template #footer v-if="infoCalificacion && infoCalificacion.infoCalifGen">
                <div class="footer-dialog" v-if="infoCalificacion.tipoModificar.includes('calificacion', 'retardos', 'conducta', 'tareas_no_hechas') || infoCalificacion.infoCalif.calificacion_id != '0'">
                    <div class="justify-content-between d-flex">
                        <vs-button
                            flat
                            danger
                            @click="active = false; calif_nueva = ''"
                        >
                            Cancelar
                        </vs-button>
                        <vs-button
                            success
                            v-if="infoCalificacion.infoCalif.calificacion_id != '0'"
                            :disabled="botonCali"
                            @click="postModificarCalif(infoCalificacion.infoCalif, infoCalificacion.infoCalifGen.escala_calificacion.tipo_escala, infoCalificacion.calificacionActual, 'modificar', infoCalificacion.tipoModificar, infoCalificacion.calificacionActual)"
                        >
                            Guardar
                        </vs-button>
                        <vs-button
                            success
                            :disabled="botonCali"
                            v-if="infoCalificacion.infoCalif.calificacion_id == '0' "
                            @click="postModificarCalif(infoCalificacion.infoCalif, infoCalificacion.infoCalifGen.escala_calificacion.tipo_escala, infoCalificacion.infoCalifGen, 'nueva', infoCalificacion.tipoModificar, infoCalificacion.calificacionActual)"
                        >
                            Aceptar
                        </vs-button>
                    </div>
                </div>
            </template>
        </vs-dialog>
    </div>
</template>
<script>
import catalogos from '../../../../../api/requests/catalogos'
export default {
    props: ['value','informacion', 'institucion', 'cicloEscolar'],
    data() {
        return{
            active: false,
            infoCalificacion: {},
            calif_nueva: '',
            errorFields: [],
            noPermitir: false,
            botonCali: false,
            modificar: {
                'calificacion': 'Calificación',
                'faltas': 'Faltas',
                'retardos': 'Retardos',
                'conducta': 'Conducta',
                'tareas_no_hechas': 'Tareas no hechas'
            },
        }
    },
    methods: {
        getInfo(){
            console.log("entro qui")
            let {infoCalif = '', calificacionActual = '', infoCalifGen = '', tipoModificar = ''} = this.informacion
            Object.assign(this.infoCalificacion = {infoCalif, calificacionActual, infoCalifGen, tipoModificar})
        },
        validarEntero(decimal){
            // Combierte el digito sin punto decimal
            if(decimal.decimales == null || decimal.decimales == '' ){
                const numero = this.calif_nueva.replace(/[^\d]/g,'')
                this.calif_nueva = numero
            }
        },
        validateGrade(valor, tipo){
            // Valida si de desbloquea el botoón para guardar la nueva calificación
            if(valor != ''){
                if(tipo == 'calificacion'){
                    if(valor > this.infoCalificacion.infoCalifGen.escala_calificacion.valor_maximo || valor < this.infoCalificacion.infoCalifGen.escala_calificacion.valor_minimo){
                        this.noPermitir = true
                        this.botonCali = true
                    }else{
                        this.noPermitir = false
                        this.botonCali = false
                    }
                }else{
                    this.noPermitir = false
                    this.botonCali = false
                }
            }else{
                this.noPermitir = false
                this.botonCali = false
            }
        },
        sanityFormModificar () {
            this.errorFields = []
            if (!this.calif_nueva){
                this.errorFields.push('calif_nueva')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        sanityFormModificarAlfa () {
            this.errorFields = []
            if (!this.alfa_nueva_acreditables && !this.alfa_nueva){
                this.errorFields.push('alfa_nueva')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async postModificarCalif(info, tipo, general, calificacion, tipoModificar, calificacionActual){
            if(calificacion == 'nueva'){
                if(tipo == 'numerica'){
                    if(this.sanityFormModificar()){
                        const loading = this.$vs.loading({
                            target: this.$refs.content
                        })
                        try {
                            const informacion = {
                                ciclo_escolar_id: this.cicloEscolar,
                                institucion_id: this.institucion,
                                registro_docente_id: general.registro_docente_id,
                                codigo_sesion_id: general.codigo_sesion_id,
                                configuracion_evaluacion_id: info.configuracion_evaluacion_id,
                                alumnos: {
                                    calificacion: this.calif_nueva,
                                    conducta: info.conducta,
                                    faltas: info.faltas,
                                    registro_academico_id: general.registro_academico,
                                    tareas_no_hechas: info.tareas_no_hechas
                                },
                                campo: tipoModificar
                            }
                            const payload = Object.assign(informacion)
                            const response= await catalogos.postAgregarCalificacion(payload)
                            loading.close()
                            this.$emit("refreshTable")
                            this.calif_nueva = ''
                            this.active = false
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                title: 'Operación éxitosa'
                            })
                        }catch(error){
                            loading.close()
                            this.active = false
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'danger',
                                position: null,
                                title: 'Hubo un error',
                                text: error.response.data.message 
                            })
                        }
                    }
                } else if(tipo == 'alfanumerica'){
                    const enviar = this.sanityFormModificarAlfa()
                    if(enviar == true){
                        const loading = this.$vs.loading({
                            target: this.$refs.content
                        })
                        try {
                            const formData = new FormData()
                            formData.append("calificacion_id", info.calificacion_id)
                            formData.append("calificacion_anterior", info.calificacion)
                            if(this.alfa_nueva_acreditables){
                                formData.append("calificacion_actual", this.alfa_nueva_acreditables)
                            }else if(this.alfa_nueva){
                                formData.append("calificacion_actual", this.alfa_nueva)
                            }
                            formData.append("campo", tipoModificar)
                            const response= await catalogos.getActualizarCalif(formData)
                            if(this.tipoCalificacion == 'promediable'){
                                if(this.alfa_nueva_acreditables){
                                    this.users[this.index_materia].periodos[this.index_calificacion].calificacion = this.alfa_nueva_acreditables
                                }else if(this.alfa_nueva){
                                    this.users[this.index_materia].periodos[this.index_calificacion].calificacion = this.alfa_nueva
                                }
                            }else if(this.tipoCalificacion == 'optativa'){
                                if(this.alfa_nueva_acreditables){
                                    this.usersOptativas[this.index_materia].periodos[this.index_calificacion].calificacion = this.alfa_nueva_acreditables
                                }else if(this.alfa_nueva){
                                    this.usersOptativas[this.index_materia].periodos[this.index_calificacion].calificacion = this.alfa_nueva
                                }
                            }
                            this.alfa_nueva_acreditables = ''
                            this.alfa_nueva = ''
                            loading.close()
                            
                            this.$emit("refreshTable")
                            this.active = false
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                title: 'Operación éxitosa'
                            })
                        }catch(error){
                            loading.close()
                            this.active = false
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'danger',
                                position: null,
                                title: 'Hubo un error',
                                text: 'Favor de contactar al administrador'
                            })
                        }
                    }
                }
            } else if(calificacion == 'modificar'){
                if(tipo == 'numerica'){
                    const enviar = this.sanityFormModificar()
                    if(enviar == true){
                        const loading = this.$vs.loading({
                            target: this.$refs.content
                        })
                        try {
                            
                            const formData = new FormData()
                            formData.append("calificacion_id", info.calificacion_id)
                            formData.append("calificacion_anterior", calificacionActual ? calificacionActual : 0)
                            formData.append("calificacion_actual", this.calif_nueva)
                            formData.append("campo", tipoModificar)
                            const response= await catalogos.getActualizarCalif(formData)
                            loading.close()
                            
                            this.$emit("refreshTable")
                            this.calif_nueva = ''
                            this.active = false
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                title: 'Operación éxitosa'
                            })
                        }catch(error){
                            loading.close()
                            this.active = false
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'danger',
                                position: null,
                                title: 'Hubo un error',
                                text: 'Favor de contactar al administrador'
                            })
                        }
                    }
                } else if(tipo == 'alfanumerica'){
                    const enviar = this.sanityFormModificarAlfa()
                    if(enviar == true){
                        const loading = this.$vs.loading({
                            target: this.$refs.content
                        })
                        try {
                            const formData = new FormData()
                            formData.append("calificacion_id", info.calificacion_id)
                            formData.append("calificacion_anterior", info.calificacion)
                            if(this.alfa_nueva_acreditables){
                                formData.append("calificacion_actual", this.alfa_nueva_acreditables)
                            }else if(this.alfa_nueva){
                                formData.append("calificacion_actual", this.alfa_nueva)
                            }
                            formData.append("campo", tipoModificar)
                            const response= await catalogos.getActualizarCalif(formData)       
                            this.$emit("refreshTable")
                            this.alfa_nueva_acreditables = ''
                            this.alfa_nueva = ''
                            loading.close()
                            this.active = false
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                title: 'Operación éxitosa'
                            })
                        }catch(error){
                            loading.close()
                            this.active = false
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'danger',
                                position: null,
                                title: 'Hubo un error',
                                text: 'Favor de contactar al administrador'
                            })
                        }
                    }
                }
            }
        },
    },
    watch: {
        value (val) {
            this.active = val
        },    
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        informacion(){
            this.getInfo()
        }
    }
}
</script>